export default __webpack_public_path__ + "static/media/completed_sp_ticket.19e82e31.svg";